import React from 'react';
import Info from './Info.svg';

const Icon = (props) => <Info {...props} />;

export default Icon;
